import { validateForm } from './helpers/form-validation'
import { playLottie } from './helpers/lottie'


let suppliersForm = $('.js-suppliers-form')
if (suppliersForm.length){
  let step = 1

  suppliersForm.find('.js-next-step').click(function (){
    if ( validateStep(step, true) ) {
      step++
      goToStep(step)
    }
  })

  suppliersForm.find('.js-prev-step').click(function (){
    step--
    goToStep(step)
  })

  suppliersForm.submit(function (e){
    e.preventDefault()

    if ( validateStep(step, true) && step === 3) {
      let formData = new FormData(this)

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: formData,
        enctype: 'multipart/form-data',
        contentType: false,
        processData: false,
        success: function (results) {

          if (results.errorMessage) {
            suppliersForm.find('.js-error-message').text(results.errorMessage).show();
            return;
          }

          suppliersForm.find('.form-header').hide()
          suppliersForm.find('.js-step-fields').hide()
          suppliersForm.find('.js-success').fadeIn()
          playLottie(suppliersForm.find('.js-lottie-checkmark'))


        },
        error: function (xhr, status, error) {
            console.error('AJAX Error:', {
                error: error,
                response: xhr.responseText,
                status: status
            });
            suppliersForm.find('.js-error-message').text('An error occurred while submitting the form. Please try again later.').show();
        }
      });

    }
  })

  suppliersForm.find('.js-close-form-popup').click(function(){
    //$(this).closest('.js-popup').find('.js-close-popup').first().click()

    suppliersForm[0].reset()
    suppliersForm.find('select').change()
    suppliersForm.find('.js-field').removeClass('focus')

    step = 1
    goToStep(step)

    $(this).closest('.js-success').hide()
    suppliersForm.find('.form-header').fadeIn()
    suppliersForm.find('.js-step-fields').fadeIn()

  })

  function goToStep(step){
    suppliersForm.find('.step-title').hide()
    suppliersForm.find('.step-title[data-step="' + step + '"]').fadeIn()

    let progressWidth = 33.33 * step
    suppliersForm.find('.progress').css('width', progressWidth + '%')
    suppliersForm.find('.js-cur-step').text('0' + step)

    let stepsC = suppliersForm.find('.fields-steps-c')
    let left = -(step - 1) * 109
    stepsC.css('left', left+'%')

    suppliersForm.closest('.js-popup').stop().animate({scrollTop:0}, 400, 'swing');
  }

  function validateStep(step){
    let fields = suppliersForm.find('.js-step-fields[data-step="'+ step +'"]')
    return validateForm(fields, true)
  }

}



// input label appearance
$(document).on('focusin', '.js-field input', function () {
  $(this).parent().addClass('focus');
});
$(document).on('focusout', '.js-field input', function () {
  if ($(this).val() == '') {
    $(this).parent().removeClass('focus');
  }
});

$('.js-field input').each(function(){
  if ($(this).val() !=- ''){
    $(this).parent().addClass('focus');
  }
})
$('form.focused').find('.js-field input').parent().addClass('focus')
